import styled, {css} from 'styled-components';
import {darkTheme} from '../../../constants/theme';

export const SkeletonBlock = styled.div<{
  $width?: `${number}${'%' | 'px'}`;
  $height?: `${number}${'px' | 'vh' | 'vw' | '%'}`;
  disableRoundedCorners?: boolean;
  disableSpaceBelow?: boolean;
}>`
  background-image: linear-gradient(to right, #e4e4e5, #f5f5f5 47%, #e4e4e5);
  position: relative;
  height: ${({$height: height}) => height || '18px'};
  width: ${({$width: width}) => width || '100%'};
  max-width: 100%;

  ${({disableRoundedCorners}) =>
    !disableRoundedCorners &&
    css`
      border-radius: 4px;
    `}
  ${({disableSpaceBelow}) =>
    !disableSpaceBelow &&
    css`
      margin-bottom: 1rem;
    `}

    ${darkTheme(css`
    background-image: linear-gradient(to right, #202020, #2a2929 47%, #282727);
  `)}
`;
